import React, { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import ManagedAccount from "@tootsweet/model/entities/ManagedAccount";
import "./styles.scss";
import SubscriptionPlanDTO from "@tootsweet/model/datatransfer/SubscriptionPlanDTO";
import { LANGUAGE } from "../../../../utils/i18n/i18n";
import { useSubscriptionPlansSelector } from "../../../../redux/actions/app";

export interface KC_TabItem {
  name: string;
  value: string;
}

interface KC_TabsProps {
  items: KC_TabItem[];
  onSelect: (value: string) => void;
  selectedIndex?: number;
  onEditClick: (account: ManagedAccount) => void;
  managedAccounts: ManagedAccount[];
  additionalButtons?: ReactNode;
}

const KC_Tabs_Border_WithEdit: React.FC<KC_TabsProps> = (
  props: KC_TabsProps
) => {
  const selectedIndex = props.selectedIndex ?? 0;
  const allSubscriptionPlans = useSubscriptionPlansSelector();

  const handleSelect = (index: number) => {
    props.onSelect(props.items[index].value);
  };

  const getAccountByTrackingId = (trackingId: string) => {
    return props.managedAccounts.find((acc) => acc.trackingID === trackingId);
  };

  return (
    <div className="config-selector no-border">
      {props.items.map((item, index) => {
        const account = getAccountByTrackingId(item.value);

        if (!account) {
          return null;
        }

        let plan: SubscriptionPlanDTO | undefined = undefined;

        if (allSubscriptionPlans && account.saasPlanId) {
          plan = allSubscriptionPlans.find((p) => p._id === account.saasPlanId);
        }

        const planName =
          (account.saasPlanId?.includes("custom")
            ? "custom"
            : (plan?.longNameL?.[LANGUAGE] ?? plan?.name)) ?? "???";

        return (
          <div
            key={item.value}
            className={`place-selector-item ${selectedIndex === index ? "place-selector-item-active" : ""} d-flex align-items-center gap-2`}
            onClick={() => {
              handleSelect(index);
            }}
          >
            <span>
              {item.name} ({planName})
            </span>
            {account && (
              <FontAwesomeIcon
                icon={faPen}
                className="ml-2"
                style={{
                  cursor: "pointer",
                  color: "#e91e63"
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  props.onEditClick(account);
                }}
              />
            )}
          </div>
        );
      })}
      {props.additionalButtons}
    </div>
  );
};

export default KC_Tabs_Border_WithEdit;
